import { BH_ROUTES } from "./constants";
const fullScreenRoutes = [
    BH_ROUTES.BETA_HUB,
    BH_ROUTES.OPT_IN_SUCCESS,
    BH_ROUTES.BETA_HUB_REGISTERED,
    BH_ROUTES.INVITEE_SUCCESS,
    BH_ROUTES.BETA_HUB_INVITEE_ACCEPTED,
    BH_ROUTES.CONNECT_CONSOLE,
    BH_ROUTES.BETA_HUB_INVITEE_COMPLETE,
];
export const isFullScreenRoute = (path) => {
    return fullScreenRoutes.includes(path);
};
//# sourceMappingURL=isFullScreenRoute.js.map